import React from 'react';
import { useIntl } from 'react-intl';
import NumberInput from 'semantic-ui-react-numberinput';
import { validationClasses } from '@/utils/errors';
import fields, { dictionaryNumberTypes } from '@/constants/fields';
import { parseNumericForNumberInput } from '../helper';

const CohortFilterValuesNumber = ({
  className,
  disabled,
  fieldType = 'integer',
  filterUUID,
  index = 0,
  onChange,
  placeholder,
  saveErrors,
  values,
}) => {
  const intl = useIntl();
  const onNumberChange = (value) => {
    const newValues = Array.isArray(values) ? [...values] : [];
    newValues[index] = value;
    onChange(newValues);
  };

  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.VALUE)));

  return (
    <NumberInput
      className={validationClasses(
        validationError,
        `aridhia-cohort-filter-values-number ${className}`,
      )}
      size="small"
      type="custom"
      allowEmptyValue
      value={parseNumericForNumberInput(values[index], fieldType)}
      disabled={disabled}
      buttonPlacement="right"
      onChange={onNumberChange}
      valueType={fieldType}
      precision={fieldType === dictionaryNumberTypes.INTEGER ? undefined : 4}
      placeholder={placeholder || intl.formatMessage({ id: 'cohort.filter.text.placeholder' })}
    />
  );
};

export default CohortFilterValuesNumber;
